import React from "react";
import Image from "next/image";
import Style from "./style.module.scss";
import { parseHtml, toWebp } from "@/utils/common";

type PartnerCardProps = {
  title: string;
  description: string;
  image: any;
};

const PartnerCard: React.FC<PartnerCardProps> = ({
  title,
  image,
  description,
}) => {
  const baseUrl =
    `${process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL}` || "";

  return (
    <div
      className={`border xl:aspect-[389/533] aspect-[266/392] border-[#B0D9F7] pt-8 px-5 h-full flex flex-col ${Style.slider_card}`}
    >
      <div className={`${Style.card_title_main}`}>
        <div className={Style.card_color_title}>
          <h4 className="xl:text-heading-3 text-heading-5 font-bold bg-[linear-gradient(302.76deg,_#8ABC00_24.39%,_#0086E6_85.79%)] bg-clip-text text-transparent">
            {title || ""}
          </h4>
        </div>
        <div className={Style.card_title}>
          <h4 className="xl:text-heading-5 text-heading-6 font-bold text-primary-text-white  font-16">
            {title || ""}
          </h4>
        </div>
      </div>

      <div className={`${Style.card_middel_title} grow`}>
        <p className="xl:text-subtitle-1 text-subtitle-3 font-regular xl:mt-6 mt-3 text-secondary-text-white  font-12">
          {description ? parseHtml(description) : ""}
        </p>

        <div className={`text-center ${Style.card_middel_img}`}>
          {image?.data?.attributes.url && (
            <Image
              src={toWebp(`${baseUrl}${image?.data?.attributes.url}`)}
              width={236}
              height={236}
              alt="Card middle image"
              className="max-w-full mx-auto opacity-50"
            />
          )}
        </div>
      </div>

      <div className={`text-center ${Style.card_bottom_img}`}>
        <Image
          src="/images/ServicesPage/slider-bottom2.png"
          width={389}
          height={153}
          alt="Card bottom image"
          className="max-w-full mx-auto"
        />
        <Image
          src="/images/ServicesPage/slider-bottom-hover.png"
          width={389}
          height={153}
          alt="Card bottom image hover"
          className="max-w-full mx-auto"
        />
      </div>
    </div>
  );
};
export default PartnerCard;
